{
  "restoredMessage": "Wiederhergestellt: {{manufacturer}} {{model}}",
  "restoreError": "Wiederherstellung fehlgeschlagen. Erneut versuchen.",
  "emptyState": "Keine blockierten FAA-Typen. Nutze den Ignorieren-Button im Tab Flugzeugzuordnung, um irrelevante Flugzeugtypen (Drohnen, Ballons usw.) zu blockieren.",
  "headers": {
    "manufacturer": "FAA-Hersteller",
    "model": "FAA-Modell",
    "restore": "Wiederhers."
  },
  "restoreTooltip": "Diesen FAA-Typ im Tab Flugzeugzuordnung wiederherstellen"
}
